var map = {
	"./01.webp": 3840,
	"./02.webp": 6788,
	"./03.webp": 624,
	"./04.webp": 1614,
	"./05.webp": 4414,
	"./06.webp": 1689,
	"./Thumbs.db": 4542
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2951;